var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var DomHelper = /** @class */ (function () {
    function DomHelper() {
        this._pointerMoveHandlers = new Map();
        this._pointerUpHandlers = new Map();
    }
    DomHelper.prototype.invokeClickEvent = function (selectorOrElement) {
        // if `selectorOrElement` is an element, use it directly
        if (selectorOrElement instanceof HTMLElement) {
            selectorOrElement.click();
            return;
        }
        // otherwise, treat it as a selector
        var source = document.querySelector(selectorOrElement);
        if (source) {
            source.click();
        }
    };
    DomHelper.prototype.downloadFileFromStream = function (fileName, contentStreamReference) {
        return __awaiter(this, void 0, void 0, function () {
            var arrayBuffer, blob, url, anchorElement;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, contentStreamReference.arrayBuffer()];
                    case 1:
                        arrayBuffer = _a.sent();
                        blob = new Blob([arrayBuffer]);
                        url = URL.createObjectURL(blob);
                        anchorElement = document.createElement('a');
                        anchorElement.href = url;
                        anchorElement.download = fileName !== null && fileName !== void 0 ? fileName : '';
                        anchorElement.click();
                        anchorElement.remove();
                        URL.revokeObjectURL(url);
                        return [2 /*return*/];
                }
            });
        });
    };
    DomHelper.prototype.requestFullscreen = function (selector) {
        return __awaiter(this, void 0, void 0, function () {
            var el;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        el = document.querySelector(selector);
                        return [4 /*yield*/, el.requestFullscreen()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DomHelper.prototype.exitFullscreen = function () {
        document.exitFullscreen();
    };
    DomHelper.prototype.eval = function (script) {
        return eval(script);
    };
    DomHelper.prototype.matchMedia = function (query) {
        return window.matchMedia(query).matches;
    };
    DomHelper.prototype.isPwaInstalled = function () {
        return (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true);
    };
    DomHelper.prototype.installPwa = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.deferredInstallPrompt) {
                            //console.warn('Install prompt not available yet');
                            return [2 /*return*/, false];
                        }
                        window.deferredInstallPrompt.prompt();
                        return [4 /*yield*/, window.deferredInstallPrompt.userChoice];
                    case 1:
                        result = _a.sent();
                        //console.log(`User response: ${result.outcome}`);
                        window.deferredInstallPrompt = null; // Only usable once
                        return [2 /*return*/, result.outcome === 'accepted'];
                }
            });
        });
    };
    DomHelper.prototype.canInstallPwa = function () {
        var ua = window.navigator.userAgent;
        var isIos = /iphone|ipad|ipod/i.test(ua);
        var isStandalone = this.isPwaInstalled();
        var isSafari = /^((?!chrome|android).)*safari/i.test(ua);
        var isIosSafari = isIos && isSafari;
        // iOS Safari: manual install
        if (isIosSafari && !isStandalone)
            return true;
        // Chrome/Edge/Opera/Brave/etc. on Android/desktop: install via prompt
        var supportsBeforeInstallPrompt = 'onbeforeinstallprompt' in window;
        return supportsBeforeInstallPrompt && !isStandalone && window.deferredInstallPrompt != null;
    };
    DomHelper.prototype.getBrowserInfo = function () {
        var ua = navigator.userAgent;
        if (/CriOS/i.test(ua))
            return 'Chrome iOS';
        if (/EdgiOS/i.test(ua))
            return 'Edge iOS';
        if (/FxiOS/i.test(ua))
            return 'Firefox iOS';
        if (/Chrome/i.test(ua))
            return 'Chrome';
        if (/Safari/i.test(ua) && !/Chrome/i.test(ua))
            return 'Safari';
        if (/Firefox/i.test(ua))
            return 'Firefox';
        if (/Edg/i.test(ua))
            return 'Edge';
        return 'Unknown';
    };
    DomHelper.prototype.isMobile = function () {
        return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent);
    };
    DomHelper.prototype.getOsInfo = function () {
        var platform = navigator.platform.toLowerCase();
        var userAgent = navigator.userAgent.toLowerCase();
        if (/android/.test(userAgent))
            return 'Android';
        if (/iphone|ipad|ipod/.test(userAgent))
            return 'iOS';
        if (/win/.test(platform))
            return 'Windows';
        if (/mac/.test(platform))
            return 'macOS';
        if (/linux/.test(platform))
            return 'Linux';
        if (/cros/.test(userAgent))
            return 'Chrome OS';
        return 'Unknown';
    };
    DomHelper.prototype.getBoundingClientRect = function (selector) {
        var el = document.querySelector(selector);
        if (el) {
            return el.getBoundingClientRect();
        }
        return null;
    };
    DomHelper.prototype.registerPointerMoveHandler = function (id, pointerMoveHandler) {
        this._pointerMoveHandlers.set(id, pointerMoveHandler);
        this.ensurePointerMoveListener();
    };
    DomHelper.prototype.unregisterPointerMoveHandler = function (id) {
        if (this._pointerMoveHandlers.delete(id))
            this.ensurePointerMoveListener();
    };
    DomHelper.prototype.ensurePointerMoveListener = function () {
        if (this._pointerMoveHandlers.size > 0 && !this._pointerMoveListener) {
            this._pointerMoveListener = this.triggerPointerMoveEvent.bind(this);
            document.addEventListener('pointermove', this._pointerMoveListener);
        }
        else if (this._pointerMoveHandlers.size == 0 && this._pointerMoveListener) {
            document.removeEventListener('pointermove', this._pointerMoveListener);
            this._pointerMoveListener = null;
        }
    };
    DomHelper.prototype.triggerPointerMoveEvent = function (event) {
        var _this = this;
        this._pointerMoveHandlers.forEach(function (handler) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, handler.invokeMethodAsync('OnPointerMove', this.mapPointerEvent(event))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    DomHelper.prototype.registerPointerUpHandler = function (id, pointerUpHandler) {
        this._pointerUpHandlers.set(id, pointerUpHandler);
        this.ensurePointerUpListener();
    };
    DomHelper.prototype.unregisterPointerUpHandler = function (id) {
        if (this._pointerUpHandlers.delete(id))
            this.ensurePointerUpListener();
    };
    DomHelper.prototype.ensurePointerUpListener = function () {
        if (this._pointerUpHandlers.size > 0 && !this._pointerUpListener) {
            this._pointerUpListener = this.triggerPointerUpEvent.bind(this);
            document.addEventListener('pointerup', this._pointerUpListener);
        }
        else if (this._pointerUpHandlers.size == 0 && this._pointerUpListener) {
            document.removeEventListener('pointerup', this._pointerUpListener);
            this._pointerUpListener = null;
        }
    };
    DomHelper.prototype.triggerPointerUpEvent = function (event) {
        var _this = this;
        this._pointerUpHandlers.forEach(function (handler) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, handler.invokeMethodAsync('OnPointerUp', this.mapPointerEvent(event))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    DomHelper.prototype.mapPointerEvent = function (event) {
        return {
            PointerId: event.pointerId,
            Width: event.width,
            Height: event.height,
            Pressure: event.pressure,
            TiltX: event.tiltX,
            TiltY: event.tiltY,
            PointerType: event.pointerType,
            IsPrimary: event.isPrimary,
            Detail: event.detail,
            ScreenX: event.screenX,
            ScreenY: event.screenY,
            ClientX: event.clientX,
            ClientY: event.clientY,
            OffsetX: event.offsetX,
            OffsetY: event.offsetY,
            PageX: event.pageX,
            PageY: event.pageY,
            MovementX: event.movementX,
            MovementY: event.movementY,
            Button: event.button,
            Buttons: event.buttons,
            AltKey: event.altKey,
            CtrlKey: event.ctrlKey,
            MetaKey: event.metaKey,
            ShiftKey: event.shiftKey,
            Type: event.type
        };
    };
    DomHelper.create = function () {
        return new DomHelper();
    };
    return DomHelper;
}());
export { DomHelper };
